<div class="lr-details-page" [class.result-mode]="isApproved || isRejected">
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <div class="error-state" *ngIf="!isLoading && errorMessage">
    <p class="error-text">{{ errorMessage }}</p>
  </div>

  <div class="result-view" *ngIf="!isLoading && !errorMessage && isOtpVerified && lorryReceipt && (isApproved || isRejected)">
    <div class="accepted-badge" *ngIf="isApproved">
      <span class="accepted-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="7.25" stroke="#0B6E99" stroke-width="1.5"/>
          <path d="M4.5 8.2l2.2 2.2 4.8-4.8" stroke="#0B6E99" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span>LR marked as Accepted</span>
    </div>

    <div class="rejected-badge" *ngIf="isRejected">
      <span class="rejected-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="7.25" stroke="#C53030" stroke-width="1.5"/>
          <path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="#C53030" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </span>
      <span>LR marked as Rejected</span>
    </div>

    <div class="lr-ticket">
      <div class="ticket-header">
        LR No: {{ lrNumber }}
      </div>

      <div class="ticket-body">
        <div class="route-row">
          <div class="route-point">
            <span class="route-icon origin-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="3" stroke="#17709c" stroke-width="1.8"/>
                <circle cx="12" cy="12" r="7" stroke="#17709c" stroke-width="1.5"/>
                <path d="M12 2v2M12 20v2M2 12h2M20 12h2" stroke="#17709c" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </span>
            <span class="route-text">{{ fromLocation }}</span>
          </div>

          <span class="route-arrow" aria-hidden="true">→</span>

          <div class="route-point">
            <span class="route-icon destination-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 21s7-5.2 7-11a7 7 0 10-14 0c0 5.8 7 11 7 11z" stroke="#17709c" stroke-width="1.6"/>
                <path d="M9.5 10.5V8.8L12 7l2.5 1.8v1.7H9.5z" stroke="#17709c" stroke-width="1.4" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="route-text">{{ toLocation }}</span>
          </div>
        </div>

        <div class="ticket-divider"></div>

        <div class="ticket-details-grid">
          <div class="ticket-detail-item">
            <span class="ticket-detail-label">Truck Number</span>
            <span class="ticket-detail-value">{{ truckNumber }}</span>
          </div>
          <div class="ticket-detail-item">
            <span class="ticket-detail-label">Reported Time</span>
            <span class="ticket-detail-value">{{ reportedTime }}</span>
          </div>
          <div class="ticket-detail-item">
            <span class="ticket-detail-label">Invoice No.</span>
            <span class="ticket-detail-value">{{ invoiceNumber }}</span>
          </div>
          <div class="ticket-detail-item">
            <span class="ticket-detail-label">Invoice Value</span>
            <span class="ticket-detail-value">{{ invoiceValue }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="details-content" *ngIf="!isLoading && !errorMessage && isOtpVerified && lorryReceipt && isPending">
    <div class="header-card">
      <div class="header-left">
        <h1 class="tsp-name">{{ tspName }}</h1>
        <p class="tsp-pan">PAN: {{ tspPan }}</p>
      </div>
      <div class="header-right">
        <span class="lr-no">LR No. - {{ lrNumber }}</span>
      </div>
    </div>

    <div class="info-card">
      <div class="info-grid">
        <div class="info-col">
          <div class="info-item">
            <span class="info-label">Truck Number</span>
            <span class="info-value">{{ truckNumber }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Driver Name</span>
            <span class="info-value">{{ driverName }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Driver Contact</span>
            <span class="info-value">{{ driverNumber }}</span>
          </div>
        </div>
        <div class="info-col">
          <div class="info-item">
            <span class="info-label">Receiver Name</span>
            <span class="info-value">{{ receiverName }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Receiver Contact</span>
            <span class="info-value">{{ receiverNumber }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Receiver Location</span>
            <span class="info-value">{{ receiverLocation }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="party-block">
        <span class="party-label">Consignor</span>
        <span class="party-name">{{ consignorName }}</span>
        <p class="party-address">{{ consignorAddress }}</p>
      </div>
      <div class="party-block">
        <span class="party-label">Consignee</span>
        <span class="party-name">{{ consigneeName }}</span>
        <p class="party-address">{{ consigneeAddress }}</p>
      </div>
    </div>

    <div class="info-card">
      <div class="details-grid">
        <div class="detail-item">
          <span class="detail-label">Invoice No.</span>
          <span class="detail-value">{{ invoiceNumber }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Invoice Value</span>
          <span class="detail-value">{{ invoiceValue }}</span>
        </div>
        <div class="detail-item" *ngIf="!isEditingReportingTime">
          <span class="detail-label">Reported Time</span>
          <span class="detail-value">{{ reportedTime }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Unloaded Time</span>
          <span class="detail-value">{{ unloadedTime }}</span>
        </div>
      </div>

      <div class="reporting-time-field" *ngIf="isEditingReportingTime">
        <label>Reporting Time</label>

        <div class="picker-row">
          <mat-form-field appearance="outline" class="picker-field">
            <input
              matInput
              [matDatepicker]="reportingPicker"
              [(ngModel)]="reportingDate"
              [max]="currentDate"
              placeholder="Choose Date"
              readonly
              (click)="reportingPicker.open()"
              (dateChange)="onReportingDateChange()"
            >
            <mat-datepicker-toggle matSuffix [for]="reportingPicker"></mat-datepicker-toggle>
            <mat-datepicker #reportingPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="time-picker-wrap">
          <mat-form-field appearance="outline" class="picker-field">
            <input
              matInput
              [ngModel]="reportingTimeDisplay"
              placeholder="Select Time"
              readonly
              (click)="openTimePicker()"
            >
          </mat-form-field>

          <app-time-picker
            *ngIf="showTimePicker"
            [restrictFuture]="true"
            [dateSelected]="reportingDate"
            class="custom-time-picker"
            (onTimePicked)="onReportingTimePicked($event)">
          </app-time-picker>
        </div>

        <p class="selected-datetime" *ngIf="reportingDate && reportingTimeDisplay">
          {{ editedReportingTimeDisplay }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="edit-time-btn"
      *ngIf="isPending && !isEditingReportingTime"
      (click)="startEditReportingTime()">
      Edit Reporting Time
    </button>

    <div class="section-card">
      <div class="section-header">Receiver's Signature</div>
      <div class="signature-body">
        <div class="signature-grid">
          <div class="detail-item">
            <span class="detail-label">Name</span>
            <span class="detail-value">{{ receiverName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Number</span>
            <span class="detail-value">{{ receiverNumber }}</span>
          </div>
        </div>
        <div class="location-block">
          <span class="detail-label">Receiver Location</span>
          <span class="detail-value location-value">{{ receiverLocation }}</span>
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-header">Driver's Signature</div>
      <div class="signature-body">
        <div class="signature-grid">
          <div class="detail-item">
            <span class="detail-label">Name</span>
            <span class="detail-value">{{ driverName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Number</span>
            <span class="detail-value">{{ driverNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Time</span>
            <span class="detail-value">{{ reportedTime }}</span>
          </div>
        </div>
        <div class="location-block">
          <span class="detail-label">Receiver Location</span>
          <span class="detail-value location-value">{{ receiverLocation }}</span>
        </div>
      </div>
    </div>

    <div class="section-card" *ngIf="photoAttachments.length">
      <div class="section-header">Photos</div>
      <div class="photos-row">
        <button
          type="button"
          class="photo-thumb"
          *ngFor="let photo of photoAttachments"
          (click)="openPhoto(photo)"
          [attr.aria-label]="'Preview ' + (photo.documentName || 'photo')">
          <img
            *ngIf="getPhotoUrl(photo) as photoUrl"
            [src]="photoUrl"
            [alt]="photo.documentName || 'Photo'"
            (error)="onPhotoError($event)"
          >
          <span class="photo-placeholder" *ngIf="!getPhotoUrl(photo)">
            {{ photo.documentName || 'Photo' }}
          </span>
        </button>
      </div>
    </div>

    <div class="section-card" *ngIf="items?.length">
      <div class="section-header">Material Details</div>
      <div class="material-table">
        <div class="material-header">
          <span class="col-product">Product</span>
          <span class="col-qty">Recd Qty</span>
          <span class="col-unit">Unit</span>
        </div>
        <div class="material-row" *ngFor="let item of items">
          <span class="col-product">{{ item.description || '-' }}</span>
          <span class="col-qty">{{ item.quantity ?? '-' }}</span>
          <span class="col-unit">{{ item.shippingUnit || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="footer-spacer"></div>
  </div>

  <div class="footer-actions" *ngIf="!isLoading && !errorMessage && lorryReceipt && isPending">
    <button type="button" class="reject-btn" (click)="openConfirm('reject')">Reject</button>
    <button type="button" class="accept-btn" (click)="openConfirm('accept')">Accept LR</button>
  </div>

  <div class="confirm-overlay" *ngIf="confirmAction" (click)="closeConfirm()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <h2 class="confirm-title">Confirm Action</h2>
      <p class="confirm-message">{{ confirmMessage }}</p>
      <p class="confirm-error" *ngIf="actionError">{{ actionError }}</p>
      <div class="confirm-actions">
        <button type="button" class="confirm-cancel" [disabled]="isActing" (click)="closeConfirm()">Cancel</button>
        <button
          type="button"
          class="confirm-submit"
          [class.accept]="confirmAction === 'accept'"
          [class.reject]="confirmAction === 'reject'"
          [disabled]="isActing"
          (click)="confirmActionSubmit()">
          {{ isActing ? 'Submitting...' : (confirmAction === 'accept' ? 'Accept LR' : 'Reject LR') }}
        </button>
      </div>
    </div>
  </div>

  <div class="photo-preview-overlay" *ngIf="previewPhotoUrl" (click)="closePhotoPreview()">
    <div class="photo-preview-modal" (click)="$event.stopPropagation()">
      <button type="button" class="photo-preview-close" (click)="closePhotoPreview()" aria-label="Close preview">×</button>
      <img [src]="previewPhotoUrl" [alt]="previewPhotoName">
      <p class="photo-preview-name">{{ previewPhotoName }}</p>
    </div>
  </div>
</div>
